import ENV from '../modules/env'

export enum FrontPlatform {
  TELEMEDICINE = ENV.TELEMEDICINE_PLATFORM_ID,
  CLINICS = ENV.CLINICS_PLATFORM_ID,
  CLINICAL_STAFF = ENV.CLINICAL_STAFF_PLATFORM_ID,
  HMVSC = ENV.HMVSC_PLATFORM_ID
}
